/*
Sohel 11/16/2022 2700912712 Added BRE Filter API
Sohel 11/17/2022 2700912712 Added BRE Filter Override Functionality
Sohel 11/17/2022 2700912712 fixed page break Issue
Akhila 06/21/2023 2700912712 conditionally disable save and finish button on submission
*/
import {createSlice} from '@reduxjs/toolkit';
import {httpPost} from '../../../util/Rest';
import {httpGet} from './../../../util/Rest';
import {submissionEnd} from '../CommonActions/commonActions';
const initialState = {
  successMsg: null,
  errorMsg: null,
  loading: false,
  addFilterRuleGroupStatus: null,
  filterRuleGroupData: {},
  filterRuleGroupId: null,
  copyFilterStatus: null,
  iscopyLoading: false,
  copySuccessMsg: null,
  copyErrorMsg: null,
  addRuleData: {},
  userMetrix: '',
  addRuleStatus: null,
};

const addFilterRuleGroup = createSlice({
  name: 'addFilterRuleGroup',
  initialState,
  reducers: {
    fetchStart: (state) => {
      state.loading = true;
      state.errorMsg = null;
    },
    fetchCopy: (state) => {
      state.iscopyLoading = true;
      state.errorMsg = null;
    },
    fetchError: (state, action) => {
      state.errorMsg = action.payload;
      state.loading = false;
    },
    fetchCopyError: (state, action) => {
      state.copyErrorMsg = action.payload;
      state.iscopyLoading = false;
    },
    postRuleAddData: (state, action) => {
      state.addRuleStatus = action.payload?.status;
      state.loading = false;
      state.errorMsg = null;
      state.addRuleData = action.payload?.response?.placeResponse;
      state.userMetrix = action.payload?.response?.userMetrix;
    },
    postCopyFilterData: (state, action) => {
      state.copyFilterStatus = action.payload?.status;
      state.iscopyLoading = false;
      state.copySuccessMsg = action.payload?.message;
      state.copyErrorMsg = null;
      state.copyCode = action.payload?.response?.id;
    },
    postFilterRuleGroupData: (state, action) => {
      state.addFilterRuleGroupStatus = action.payload?.status;
      state.loading = false;
      state.errorMsg = null;
      state.successMsg = action.payload?.message;
      state.filterRuleGroupId=action.payload?.response?.id;
      state.addRuleData = action.payload?.response?.placeResponse;
      state.userMetrix = action.payload?.response?.userMetrix;
    },
    getFilterRuleGroupData: (state, action) => {
      state.filterRuleGroupData = action.payload;
      state.loading = false;
      state.errorMsg = null;
      state.addFilterRuleGroupStatus = action.payload?.status;
    },
    resetMsg: (state) => {
      state.successMsg = null;
      state.errorMsg = null;
      state.loading = false;
      state.addFilterRuleGroupStatus = null;
    },
    resetRuleStatus: (state, action) => {
      state.addRuleStatus = null;
    },
    resetData: (state) => {
      state.filterRuleGroupData = {};
      state.successMsg = null;
      state.errorMsg = null;
      state.loading = false;
      state.addFilterRuleGroupStatus=null;
      state.filterRuleGroupId=null;
    },
    resetCopyFilterData: (state, action) => {
      state.copyFilterStatus = null;
      state.iscopyLoading = false;
      state.copySuccessMsg = null;
      state.copyErrorMsg = null;
    },
  },
});
export default addFilterRuleGroup.reducer;
const {
  fetchStart,
  fetchError,
  fetchCopy,
  postCopyFilterData,
  resetCopyFilterData,
  fetchCopyError,
  resetMsg,
  postFilterRuleGroupData,
  getFilterRuleGroupData,
  resetData,
  postRuleAddData,
  resetRuleStatus,
} = addFilterRuleGroup.actions;

export const postFilterRuleGroup = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`rules/save/filterrulegroup`, details)
      .then((data) => {
        dispatch(submissionEnd());
        if (data && data.status && data.status === 200 && data?.response?.userMetrix) {
          dispatch(postRuleAddData(data));
        } else if (data && data.status && data.status === 200) {
          dispatch(postFilterRuleGroupData(data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const postCopyFilter = (details) => {
  return (dispatch) => {
    dispatch(fetchCopy());
    httpPost(`rules/save/copy/filter`, details)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(postCopyFilterData(data));
        } else {
          dispatch(fetchCopyError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchCopyError(error.message));
      });
  };
};
export const fetchFilterRuleGroup = (filterRuleGroupId) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`rules/find/filter/rules/${filterRuleGroupId}`)
      .then((data) => {
        if (data?.status === 200 && data?.data?.status === 400) {
          dispatch(fetchError(data));
        } else if (data && data.status && data.status === 200) {
          dispatch(getFilterRuleGroupData(data.response));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const resetMessage = () => {
  return (dispatch) => {
    dispatch(resetMsg());
  };
};

export const resetFilterRuleGroupData = () => {
  return (dispatch) => {
    dispatch(resetData());
  };
};
export const resetCopyFilter = () => {
  return (dispatch) => {
    dispatch(resetCopyFilterData());
  };
};

export const ResetAddRule = () => {
  return (dispatch) => {
    dispatch(resetRuleStatus());
  };
};
